import { render, staticRenderFns } from "./tzddtgzMb.vue?vue&type=template&id=55aa29c0&scoped=true&"
import script from "./tzddtgzMb.vue?vue&type=script&lang=js&"
export * from "./tzddtgzMb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aa29c0",
  null
  
)

export default component.exports